import { render, staticRenderFns } from "./ThroughputReport.vue?vue&type=template&id=6b5f3d02&scoped=true&"
import script from "./ThroughputReport.vue?vue&type=script&lang=ts&"
export * from "./ThroughputReport.vue?vue&type=script&lang=ts&"
import style0 from "./ThroughputReport.vue?vue&type=style&index=0&id=6b5f3d02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5f3d02",
  null
  
)

export default component.exports